import { useTranslation } from 'react-i18next';
import { type TestToneSource, useTestTone } from 'providers/TestToneProvider';
import { TestToneActionButton } from './TestToneButton.styles';

type Props = {
  sinkId: string | undefined;
  source: TestToneSource;
  /** Tells the two buttons apart for screen readers; their visible text is the same. */
  name: string;
  className?: string;
};

export const TestToneButton = ({ sinkId, source, name, className }: Props) => {
  const { t } = useTranslation();
  const { playingSource, play } = useTestTone();
  const playing = playingSource === source;
  const otherPlaying = playingSource !== null && !playing;

  return (
    <TestToneActionButton
      className={className}
      disabled={sinkId === undefined || otherPlaying}
      aria-busy={playing}
      aria-label={name}
      onClick={() => sinkId !== undefined && void play(sinkId, source)}
    >
      {playing ? t('audio.settings.playingTestTone') : t('audio.settings.playTestTone')}
    </TestToneActionButton>
  );
};
